import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Logo } from '@/components/layout/Logo';

export function NotFoundPage() {
  return (
    <div className="text-center py-20">
      <Logo size={48} className="mb-3" />
      <h1 className="text-2xl font-extrabold text-ink">Page not found</h1>
      <p className="text-sm text-slate-500 mt-1">The route you followed doesn't exist.</p>
      <Link to="/devices" className="inline-block mt-5">
        <Button variant="primary">Back to devices</Button>
      </Link>
    </div>
  );
}
